import src from "IMAGE";
export default { src, width: 256, height: 256, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAR0lEQVR42o2Puw0AIAhEcVO1U6fQ3trPTA4lFCQUErzkEsi78AEQCtFXMmjKJXXyEzoUB6iWYxuDucdZaO6J2QFzxfeR2psX6o00O6I0MsMAAAAASUVORK5CYII="};
